import KycV2ApprovalList from "../../Kyc/KycV2ApprovalList";

const MobileKycV2Page = () => {
  return (
    <div
      className="flex flex-col w-full"
      style={{ height: "calc(100dvh - 56px)" }}
    >
      <div className="h-[56px] border-b border-border-subtle bg-bg-page-body flex flex-row sticky top-0 bg-white z-10 px-4 shrink-0">
        <div className="flex flex-row justify-between items-center w-full">
          <p className="text-text-base text-[16px] font-semibold">KYC V2</p>
        </div>
      </div>
      <div className="px-3 mt-3 flex min-h-0 flex-1 flex-col">
        <KycV2ApprovalList />
      </div>
    </div>
  );
};

export default MobileKycV2Page;
